module.exports = __webpack_public_path__ + "media/images/Canada-groom-image3-4bc9aa3b5a130a1021d6f1c5af8fa0fa.jpg";